import axios from 'axios'

export const PrintJobLogApi = {
    http: axios.create(),
    log(data) {
        return this.http.post(Routing.generate('print_job_log'), data);
    }
}
